import axios from "axios";
import { studentURL } from "../config";

const KahootRoomScoreBoardAxios = axios.create({
  baseURL: studentURL
})

KahootRoomScoreBoardAxios.defaults.headers.common = {
  ...(KahootRoomScoreBoardAxios.defaults.headers.common || {}),
  ApiKey: 'TESTDEV-0000-1111-2222-333333333333'
}

const fetchKahootRoomScoreBoard = () => KahootRoomScoreBoardAxios('/kahootroomscoreboard')

export default fetchKahootRoomScoreBoard